import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "../../../install/types.ts";

export const SelfHostedComponents = InstallSpec({
  "iam-write": ItemComponent({
    type: "string",
    label: "Environment",
    description: "Allows P0 to provide ssh access to self-hosted compute",
    maturity: "ga",
    schema: {
      environmentLabel: Element({
        label: "Environment Label",
        description:
          "Provide an optional user-friendly label for the environment",
        type: "string",
      }),
      userSuffix: Element({
        label: "User Suffix",
        description:
          "Provide an optional suffix that will be appended to the linux user name. Helps to avoid conflicts with existing users managed outside of P0",
        type: "string",
      }),
      connectorArn: Element({
        label: "Connector ARN",
        description:
          "ARN of the p0-linux-connector Lambda function for this environment",
        type: "string",
      }),
      sshSessionAuditSource: Element({
        label: "SSH Session Audit Source",
        description: "Source for collecting SSH session recordings",
        type: "select",
        default: "instance",
        options: {
          instance: Option({
            label: "Instance",
            schema: {},
          }),
          splunk: Option({
            label: "Splunk",
            schema: {
              sessionAudit: Element({
                label: "Splunk Session Audit",
                description:
                  "Select an installed Splunk Session Audit component",
                type: "dynamic",
              }),
              index: Element({
                label: "Index",
                type: "string",
                description:
                  "Splunk index containing SSH session recordings in tlog format",
              }),
            },
          }),
        },
      }),
    },
  }),
});
